'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPassword = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loginError: state.auth.loginError,
    loadingForgotPass: state.user.loadingForgotPass,
    messageForgotPass: state.user.messageForgotPass
  };
}, (0, _extends3.default)({}, authActions, userActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ForgotPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      email: '',
      emailValidate: true,
      showModalSuccess: false
    }, _this.onChangeEmail = function (event) {
      var emailValidate = false;
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value) || event.target.value === '') {
        emailValidate = true;
      }
      _this.setState({
        email: event.target.value,
        emailValidate: emailValidate
      });
    }, _this.handleSubmit = function () {
      var emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(_this.email.value);
      if (emailValidate) {
        _this.props.forgotPass(_this.email.value);
      } else {
        _this.setState({
          emailValidate: emailValidate
        });
      }
    }, _this.handleCloseModalSuccess = function () {
      _this.setState({ showModalSuccess: false });
    }, _this.hanldeOpenModalSuccess = function () {
      _this.setState({ showModalSuccess: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loadingForgotPass && !nextProps.loadingForgotPass) {
        this.hanldeOpenModalSuccess();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ForgotPassword.scss');
      var _state = this.state,
          emailValidate = _state.emailValidate,
          email = _state.email,
          showModalSuccess = _state.showModalSuccess;
      var _props = this.props,
          loadingForgotPass = _props.loadingForgotPass,
          messageForgotPass = _props.messageForgotPass;

      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        loadingForgotPass && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(_reactHelmet2.default, { title: 'ForgotPassword' }),
        _react2.default.createElement(
          'div',
          { className: styles.loginContent },
          _react2.default.createElement(
            'div',
            { className: styles.leftContent },
            _react2.default.createElement(
              'div',
              { className: styles.headerLogin },
              'Qu\xEAn m\u1EADt kh\u1EA9u'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                { className: styles.groupInput },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  { className: styles.inputIcon },
                  _react2.default.createElement('i', {
                    className: 'fa fa-user-o ' + styles.icon,
                    'aria-hidden': 'true'
                  })
                ),
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  inputRef: function inputRef(ref) {
                    return _this2.email = ref;
                  },
                  onChange: this.onChangeEmail,
                  className: styles.inputLogin,
                  type: 'text',
                  placeholder: 'Email c\u1EE7a b\u1EA1n',
                  value: email
                })
              ),
              emailValidate === false && _react2.default.createElement(
                'div',
                { className: styles.help },
                'Email kh\xF4ng h\u1EE3p l\u1EC7!'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.buttonLogin,
                onClick: function onClick() {
                  return _this2.handleSubmit();
                }
              },
              'X\xC1C NH\u1EACN'
            )
          ),
          _react2.default.createElement('div', { className: styles.rightContent })
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalSuccess,
            hide: this.handleCloseModalSuccess,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalSuccess
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              messageForgotPass
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: this.handleCloseModalSuccess
                },
                'X\xE1c nh\u1EADn'
              )
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  forgotPass: _react.PropTypes.func,
  loadingForgotPass: _react.PropTypes.bool,
  messageForgotPass: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = ForgotPassword;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/ForgotPassword.js
// module id = 1677
// module chunks = 0